import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarrierPalletMatrixTokenGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot): boolean | UrlTree {
    const expectedToken = environment.carrierPalletMatrixAccessToken;
    const token = next.queryParamMap.get('token');

    if (expectedToken && token === expectedToken) {
      return true;
    }

    return this.router.parseUrl('/not-found');
  }
}
